import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TextbookDrawerComponent } from './textbook-drawer.component';

@NgModule({
  declarations: [TextbookDrawerComponent],
  exports: [TextbookDrawerComponent],
  imports: [CommonModule],
})
export class TextbookDrawerModule {}
